'use client'

import Reveal from '../Reveal'

const assets = [
  { sym: 'BTC', name: 'Bitcoin', ltv: '70%' },
  { sym: 'ETH', name: 'Ethereum', ltv: '70%' },
  { sym: 'SOL', name: 'Solana', ltv: '60%' },
  { sym: 'USDC', name: 'USD Coin', ltv: '90%' },
  { sym: 'USDT', name: 'Tether', ltv: '90%' },
  { sym: 'BNB', name: 'BNB', ltv: '55%' },
  { sym: 'XRP', name: 'XRP', ltv: '50%' },
  { sym: 'ADA', name: 'Cardano', ltv: '50%' },
  { sym: 'AVAX', name: 'Avalanche', ltv: '55%' },
  { sym: 'LINK', name: 'Chainlink', ltv: '55%' },
  { sym: 'DOT', name: 'Polkadot', ltv: '50%' },
  { sym: 'MATIC', name: 'Polygon', ltv: '55%' },
]

function Row({ reverse = false }: { reverse?: boolean }) {
  return (
    <div className="flex overflow-hidden select-none">
      <div
        className={`flex gap-4 pr-4 ${reverse ? 'animate-[marquee-r_38s_linear_infinite]' : 'animate-[marquee-l_38s_linear_infinite]'}`}
      >
        {[...assets, ...assets].map((a, i) => (
          <div
            key={`${a.sym}-${i}`}
            className="flex items-center gap-3 shrink-0 glass rounded-xl px-5 py-3.5"
          >
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-steel-600 to-steel-800 ring-1 ring-electric-500/30 flex items-center justify-center text-[11px] font-display font-bold text-electric-200">
              {a.sym}
            </div>
            <div className="leading-tight">
              <div className="text-sm text-white font-medium">{a.name}</div>
              <div className="text-[11px] text-steel-400">Up to {a.ltv} LTV</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default function Assets() {
  return (
    <section id="assets" className="relative py-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-xs tracking-[0.3em] text-electric-400 uppercase mb-3">
            Collateral you can use
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl text-chrome">
            50+ digital assets accepted
          </h2>
          <p className="mt-4 text-steel-300">
            Pledge major coins and stablecoins as collateral. The higher the
            loan-to-value, the more liquidity you unlock.
          </p>
        </Reveal>
      </div>

      <div className="space-y-4">
        <Row />
        <Row reverse />
      </div>

      <style jsx global>{`
        @keyframes marquee-l {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-r {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </section>
  )
}
